import ArticleAuthor from './ArticleAuthor';

export default ArticleAuthor;
